// extracted by mini-css-extract-plugin
export default {"container":"TN-z","topReviewHeading":"UN-z","criticalReview":"VN-z","favorableReview":"WN-z","vsSeparator":"XN-z"};